import styled from 'styled-components';

export const StyledResetPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .reset-password-paper-container {
    padding: 50px;
    width: 400px;
    margin: 10% auto;
  }

  .reset-password-btn {
    width: 100%;
    margin-top: 20px;
  }

  .mt-2 {
    margin-top: 16px;
  }

  .mb-4 {
    margin-bottom: 32px;
  }

  @media (max-width: 768px) {
    margin-top: 3rem;
    .reset-password-paper-container {
      width: 90%;
      padding: 30px;
    }
  }
`;
